import { NavLink } from "react-router-dom";
import { getMainSiteUrl, IS_LANDING } from "../../constants/appConfig";

export function getNavHref(to) {
  if (!IS_LANDING) return to;
  const mainSite = getMainSiteUrl();
  return `${mainSite}${to.startsWith("/") ? to : `/${to}`}`;
}

function resolveClassName(className, isActive = false) {
  if (typeof className === "function") {
    return className({ isActive });
  }
  return className || "";
}

export function SiteNavLink({
  to,
  className,
  activeClassName = " is-active",
  onClick,
  children,
  ...rest
}) {
  if (IS_LANDING) {
    return (
      <a
        href={getNavHref(to)}
        className={resolveClassName(className, false)}
        onClick={onClick}
        {...rest}
      >
        {children}
      </a>
    );
  }

  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        typeof className === "function"
          ? className({ isActive })
          : `${className || ""}${isActive ? activeClassName : ""}`
      }
      {...rest}
    >
      {children}
    </NavLink>
  );
}

export function SiteBrandLink({ to = "/", className, onClick, children, ...rest }) {
  if (IS_LANDING) {
    return (
      <a href={getNavHref(to)} className={className} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <NavLink to={to} onClick={onClick} className={className} {...rest}>
      {children}
    </NavLink>
  );
}
